import React, {useContext} from 'react';
import {Stack, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {logout} from '../../services/AuthServices';
import {DispatchContext} from '../../store';
import {SNACKBAR_OPEN} from '../../reducers';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import LogoutIcon from '@mui/icons-material/Logout';

export default function HeaderMenu({handleClick, anchorEl, setAnchorEl}) {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('user'));
  const dispatch = useContext(DispatchContext)
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onSignOut = () => {
    logout(dispatch).then(res => {
      navigate('/login');
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Logged out successfully'}
      });
    });
  };

  return (
    <Box sx={{ml: 2}}>
      <Stack className={'hand-cursor'} onClick={handleClick}>
        <Typography variant={'button'} fontWeight={700} className={'dark-color text-capitalize'}>
          Welcome! <span style={{fontWeight: 400}}>{userData?.first_name || 'No name'}</span>
        </Typography>
      </Stack>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={onSignOut}>
          Logout
          <LogoutIcon sx={{fontSize: 18, ml: 1}}/>
        </MenuItem>
      </Menu>
    </Box>
  );
}

